import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
//Redux
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'store/actions';
//FilePond
import { FilePond, registerPlugin } from 'react-filepond';
//FilePond Packages
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
//FilePond Styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css';
// Utils
import { checkImageUrl, inputChange } from 'utils/modules/Handlers';
// Modules
import FeedPost from './modules/FeedPost';
// Components
import Icons from 'components/Icons';
import Seprator from 'components/Separator';
// Assets
import './listingWaggle.scss'
import NoUser from 'assets/images/no_user.jpg'
import LinkPreview from 'components/LinkPreview';

// FilePond Register Plug-ins
registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginFileEncode,
    FilePondPluginMediaPreview
)

const ListingWaggle = ({ id }) => {
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { offset } = useSelector((state) => state.feed)
    const [posts, setPosts] = useState([])
    const [files, setFiles] = useState([])
    const [matterPort, setMatterPort] = useState(null)
    const [youtube, setYoutube] = useState(null)
    const [form, setForm] = useState({
        title: {
            value: ''
        },
        body: {
            value: ''
        },
    })

    useEffect(() => {
        initFetchPost();
    }, [])

    const initFetchPost = async() => {
        const data =  await dispatch(actions.feed.fetchListingWaggles(id))
        setPosts(data.results)
    }

    const onFocus = (event) => {
        if (event.target.innerText === 'Want to share your thoughts?') {
            event.target.innerText = ""
        }
    }

    const onBlur = (event) => {
        if (event.target.innerText === "") {
            event.target.innerText = "Want to share your thoughts?"
        }
    }

    const getMatterportData = async(event, url) => {
        const response = await fetch(`https://jsonlink.io/api/extract?url=${url}`);
        const data = await response.json();
        setMatterPort(data);
        // const urlfied = `<span class="waggle-link" contenteditable="false">${data.title}</span>`;
        event.target.innerHTML = event.target.innerHTML.replace(url, '');
        event.target.focus();
    }

    const getYoutubeData = async (event, url) => {
        const requestUrl = `http://youtube.com/oembed?url=${url}&format=json`;
        const result = await axios.get(requestUrl);
        setYoutube(result.data);
        event.target.innerHTML = event.target.innerHTML.replace(url, '');
        event.target.focus();
    };

    const onInput = (event) => {
        const text = event.target.innerText
        const urlRegexYoutube = /(https?:\/\/www.youtube.com\/[^\s]+)/g;
        const urlRegexMatterport = /(https?:\/\/(my.matterport.com|matterport.com)\/[^\s]+)/g;
        if (urlRegexYoutube.test(text) && !youtube) {
            text.replace(urlRegexYoutube, async (url) => {
                getYoutubeData(event, url);
            })
        }
        if (urlRegexMatterport.test(text) && !matterPort) {
            text.replace(urlRegexMatterport, async (url) => {
                getMatterportData(event, url)
            })
        }
        inputChange({ setForm: setForm, key: 'body', value: 'value', data: text })
    }

    const clearForm = () => {
        document.getElementById('waggle-title').value = ''
        document.getElementById('description').innerText = "Want to share your thoughts?"
    }

    const onPaste = (event) => {
        event.preventDefault()
        const text = event.clipboardData.getData('text/plain')
        event.target.innerHTML = text
        onInput(event)
    }

    const onMediaClick = () => {
        document.getElementsByClassName('filepond--browser')[0].click()
    }

    const onChangeInput = ({ event, type }) => {
        const data = event.target.value;
        inputChange({ setForm: setForm, key: type, value: 'value', data: data })
    }
    

    const onFileUpload = (files) => {
        let fileData = []
        try {
            files.map(file => {
                return fileData.push(file.getFileEncodeDataURL())
            })
            if (fileData.length > 0) setFiles(fileData);
            else setFiles([])
        } catch (error) {
            console.log(error)
        }
    }

    const onPost = useCallback(async() => {
        const { title, body } = form
        try {
            const data = {
                user: user.id,
                title: title.value,
                body: body.value,
                files: files,
                listing: id,
            }
            await dispatch(actions.feed.postWaggle(data));
            initFetchPost();
            setFiles([]);
            clearForm();
        } catch (error) {
            console.log(error)
        }
    }, [files, form])

    return (
        <div className="waggle-listing">
            {
                user.id &&
                <div className="waggle-form--container">
                    <div className="form-area">
                        <img className="user-profile-picture" src={checkImageUrl(user.profile_photo, NoUser)} alt="" />
                        <Seprator width={25} />
                        <div className="waggle-inputs">
                            <input 
                                type="text" 
                                placeholder="Enter you waggle title here"
                                className="title"
                                id='waggle-title'
                                required
                                onChange={(event) => onChangeInput({event, type: "title"})} 
                            />
                            <Seprator height={10} />
                            <p 
                                contentEditable="true" 
                                suppressContentEditableWarning={true}
                                id="description" 
                                onFocus={(event) => onFocus(event)} 
                                onBlur={(event) => onBlur(event)}
                                onInput={(event) => onInput(event)}
                                onPaste={(event) => onPaste(event)}
                            >
                                Want to share your thoughts?
                            </p>
                        </div>
                    </div>
                    <LinkPreview 
                        data={matterPort} 
                        setData={setMatterPort} 
                        logo={<Icons.Matterport className="link-logo" />}
                    />
                    <LinkPreview 
                        data={youtube} 
                        setData={setYoutube} 
                        logo={<Icons.Youtube className="link-logo" />}
                    />
                    <div className="upload-area">
                        <div>
                            <div className={`listing-input ${files.length > 0 && 'active'}`} id="upload-image" onClick={onMediaClick}>
                                <Icons.Media color={`${files.length > 0 ? 'white' : '#2a2a2a'}`} />
                                <Seprator width={15} />
                                <p>
                                    {files.length > 0 ? `${files.length} Files` : "Media" }
                                </p>
                            </div>
                        </div>
                        <button 
                            className={`button compose-button ${((files.length > 0 && form.title.value) || form.title.value) && 'active'}`}
                            onClick={() => onPost()}
                        >
                            <Icons.WaggleIcon height={24} width={19} /> 
                            <p>Waggle!</p>
                        </button>
                    </div>
                    <div className="file-area">
                        <FilePond
                            id="document"
                            className='waggle-upload'
                            files={files}
                            allowMultiple={true}
                            oninit={() => {}}
                            maxFileSize="20MB"
                            imagePreviewHeight={110}
                            allowFileTypeValidation={true}
                            acceptedFileTypes={['image/*', 'video/*']}
                            onupdatefiles={(fileItems) => {
                                onFileUpload(fileItems);
                            }}
                        />
                        <Seprator height={20} />
                    </div>
                </div>
            }
            {
                posts.length > 0
                ? posts.map((post, index) => {
                    return (<FeedPost data={post} key={index} />)
                })
                : <div className='waggle-feeds'>
                    <p className='empty'>No waggles to show.</p>
                </div>  
            }

        </div>
    )
}


export default ListingWaggle;